import React from 'react';
import { ReactComponent } from 'Common/components/Icons/ear-protection.svg';

const EarProtection = () => <ReactComponent className="MuiSvgIcon-root" />;

export default EarProtection;
